module.exports = __webpack_public_path__ + "41d9bbacfdfdb60a080ff04de9df8aa6.svg";